var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconValuable64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_11218)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2072 8.50293H31.9494H44.6915C46.1639 8.50293 47.5543 9.1807 48.4614 10.3405L56.606 20.7555C57.9407 22.4622 57.9622 24.8527 56.6586 26.5832L35.7918 54.2816C34.2015 56.3926 31.2009 56.8147 29.0898 55.2243C28.7342 54.9564 28.4177 54.6402 28.1494 54.2848L7.24452 26.5839C5.9385 24.8533 5.95907 22.4609 7.29466 20.753L15.4374 10.3405C16.3444 9.1807 17.7348 8.50293 19.2072 8.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6537 24.0273H57.9262L35.1995 54.9031L31.9995 56.5031L33.5995 51.7031L42.6537 24.0273Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2072 8.50293H31.9494H44.6915C46.1639 8.50293 47.5543 9.1807 48.4614 10.3405L56.606 20.7555C57.9407 22.4622 57.9622 24.8527 56.6586 26.5832L35.7918 54.2816C34.2015 56.3926 31.2009 56.8147 29.0898 55.2243C28.7342 54.9564 28.4177 54.6402 28.1494 54.2848L7.24452 26.5839C5.9385 24.8533 5.95907 22.4609 7.29466 20.753L15.4374 10.3405C16.3444 9.1807 17.7348 8.50293 19.2072 8.50293Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7875 8.9442L41.3173 21.3698C42.1601 22.5975 42.3833 24.1474 41.9214 25.563L31.9494 56.1206L21.9774 25.563C21.5154 24.1474 21.7387 22.5975 22.5814 21.3698L31.1112 8.9442C31.3008 8.66799 31.6143 8.50293 31.9494 8.50293C32.2844 8.50293 32.5979 8.66799 32.7875 8.9442Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52539 23.458H57.3734",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_11218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconValuable64);
export default __webpack_public_path__ + "static/media/pictogramBeaconValuable64.b0ea6ff21af4979f8173c59b8a928bb9.svg";
export { ForwardRef as ReactComponent };